import { render } from "./UserSelection.vue?vue&type=template&id=37ac64d2"
import script from "./UserSelection.vue?vue&type=script&lang=js"
export * from "./UserSelection.vue?vue&type=script&lang=js"

import "./UserSelection.vue?vue&type=style&index=0&id=37ac64d2&lang=scss"
script.render = render

export default script